import React from 'react';

export const VOTER_ORANGE = '#E07000';

const iconStyle = { width: 16, height: 16, display: 'block' };

export const voterIcons = {
    call: (
        <svg style={iconStyle} viewBox="0 0 24 24" fill="white" aria-hidden="true">
            <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V20a1 1 0 01-1 1C10.4 21 3 13.6 3 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.46.57 3.58a1 1 0 01-.24 1.01l-2.21 2.2z" />
        </svg>
    ),
    text: (
        <svg style={iconStyle} viewBox="0 0 24 24" fill="white" aria-hidden="true">
            <path d="M20 2H4a2 2 0 00-2 2v18l4-4h14a2 2 0 002-2V4a2 2 0 00-2-2zm-2 11H6v-2h12v2zm0-3H6V8h12v2z" />
        </svg>
    ),
    slip: (
        <svg style={iconStyle} viewBox="0 0 24 24" fill="white" aria-hidden="true">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
            <path d="M12.05 2.003C6.53 2.003 2.04 6.493 2.04 12.013c0 1.77.46 3.45 1.27 4.91L2 22.003l5.19-1.36a9.96 9.96 0 004.86 1.25c5.52 0 10.01-4.49 10.01-10.01 0-5.52-4.49-9.88-10.01-9.88zm0 18.26a8.24 8.24 0 01-4.2-1.15l-.3-.18-3.08.81.82-3-.2-.31a8.23 8.23 0 01-1.26-4.37c0-4.55 3.7-8.25 8.25-8.25 4.55 0 8.25 3.7 8.25 8.25-.03 4.55-3.73 8.25-8.28 8.25z" />
        </svg>
    ),
    check: (
        <svg style={iconStyle} viewBox="0 0 24 24" fill="white" aria-hidden="true">
            <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm-1.1 14.2l-3.6-3.6 1.4-1.4 2.2 2.2 4.6-4.6 1.4 1.4-6 6z" />
        </svg>
    ),
    prachar: (
        <svg style={iconStyle} viewBox="0 0 24 24" fill="white" aria-hidden="true">
            <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
        </svg>
    ),
    print: (
        <svg style={iconStyle} viewBox="0 0 24 24" fill="white" aria-hidden="true">
            <path d="M19 8h-1V3H6v5H5a3 3 0 00-3 3v6h4v4h12v-4h4v-6a3 3 0 00-3-3zM8 5h8v3H8V5zm8 14H8v-4h8v4zm4-4h-2v-2H6v2H4v-4a1 1 0 011-1h14a1 1 0 011 1v4z" />
        </svg>
    ),
    family: (
        <svg style={{ width: 17, height: 17, display: 'block' }} viewBox="0 0 24 24" fill="white" aria-hidden="true">
            <circle cx="7" cy="5.5" r="2.3" />
            <path d="M3.8 19.5v-5.2c0-1.5 1.2-2.7 2.7-2.7h1c1.5 0 2.7 1.2 2.7 2.7v5.2H3.8z" />
            <circle cx="17" cy="5.5" r="2.3" />
            <path d="M13.8 19.5v-5.2c0-1.5 1.2-2.7 2.7-2.7h1c1.5 0 2.7 1.2 2.7 2.7v5.2h-6.4z" />
            <circle cx="12" cy="9.2" r="1.8" />
            <path d="M9.8 19.5v-3.6c0-1.2 1-2.2 2.2-2.2s2.2 1 2.2 2.2v3.6H9.8z" />
        </svg>
    )
};
